import { React, useState, useEffect } from 'react'
import '../../layouts/stylesheets/loader-style.css'
import { AiTwotoneSnippets } from 'react-icons/ai'

const CampaignType = (props) => {
  const [loading] = useState(false)
  const [selectedCampaignType, setSelectedCampaignType] = useState('')
  const [formErrors, setFormErrors] = useState({})

  // const platform = props.campaignData.platform;

  const campaignTypesByPlatform = {
    google: [
      'Search campaigns',
      'Display campaigns',
      'Video campaigns',
      'Shopping campaigns',
      'App campaigns',
      'Performance Max',
    ],
    facebook: [
      'Image ads',
      'Video ads',
      'Carousel ads',
      'Slideshow ads',
      'Collection ads',
      'Instant Experience ads',
      'Messenger ads',
      'Sponsored Messages',
      'Lead ads',
      'Dynamic ads',
    ],
    linkedin: [
      'Sponsored content',
      'Sponsored messaging',
      'Sponsored InMail',
      'Text ads',
      'Dynamic ads',
      'Conversation ads',
    ],
    tiktok: [
      'In-Feed Ads',
      'Brand Takeover',
      'TopView Ads',
      'Branded Hashtag Challenge',
      'Branded Effects',
      'Branded AR Content',
      'Custom Influencer Packages',
    ],
    x: [
      'Promoted tweets',
      'Promoted accounts',
      'Promoted trends',
      'In-stream video ads',
      'Website cards',
      'Conversational ads',
      'App install ads',
      'Direct message ads',
    ],
    mailchimp: ['Custom Campaign'],
    microsoft: [
      'Search campaigns',
      'Display campaigns',
      'Video campaigns',
      'Shopping campaigns',
      'App campaigns',
    ],
  }

  useEffect(() => {
    const handleNav = (props) => {
      props.setNav('')
      if (props.nav === 'forward') {
        if (selectedCampaignType === '') {
          setFormErrors((currentErrors) => ({
            ...currentErrors,
            name: 'Please select a campaign objective.',
          }))
          return
        } else {
          props.setActivePage('campaignObjective')
        }
      } else if (props.nav === 'back') {
        props.setActivePage('source')
      }
    }
    handleNav(props)
  }, [props, selectedCampaignType])

  const handleSelect = (event) => {
    setSelectedCampaignType(event.target.id)
    props.setCampaignData({
      ...props.campaignData,
      campaignType: event.target.id,
    })
  }

  return loading ? (
    <>
      <div className="loader-wrapper">
        <div className="flex justify-center items-center">
          <div className="grid gap-10">
            <div className="loader"></div>
            <div className="text-center font-unbounded">Loading...</div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className="mb-6 w-full max-w-5xl mx-auto h-auto px-4 overflow-x-clip">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div className="flex items-center col-span-full">
          <p className="w-full uppercase mx-auto flex items-center gap-2 font-unbounded">
            <AiTwotoneSnippets />
            Select your Campaign Type
          </p>
        </div>
        <h3 className="col-span-full w-full text-2xl font-unbounded">
          Set up your M-Link
        </h3>
        <p className="col-span-full w-full text-xl text-[#000000] mx-auto mb-8">
          {
            'Choose the ad format used in your campaign. This helps us match your campaign data with landing page activity for accurate reporting.'
          }
        </p>
        {campaignTypesByPlatform[props.campaignData.platform].map(
          (campaignType) => (
            <div key={campaignType} className="w-full">
              <input
                id={campaignType}
                name="source"
                type="radio"
                className="hidden"
                onClick={handleSelect}
              />
              <label
                htmlFor={campaignType}
                className="radio-label font-unbounded h-14 flex justify-center items-center bg-metrinome-shadow-green text-black text-center rounded-3xl placeholder-black text-lg font-light w-full px-4 cursor-pointer"
              >
                {campaignType}
              </label>
            </div>
          )
        )}
      </div>
      {formErrors.name ? (
        <p
          className="mx-auto w-fit text-left font-bold p-2.5"
          style={{ color: '#f44' }}
        >
          {formErrors.name}
        </p>
      ) : (
        ''
      )}
    </div>
  )
}

export default CampaignType
